import sanitize from 'sanitize-html'
import jump from 'jump.js'

export function decodeHTML(html) {
	const txt = document.createElement('textarea')
	txt.innerHTML = html
	return txt.value
}

const commonSanitizeOption = {
  allowedTags: [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'pre', 'address', 'strong', 'q',
    'blockquote', 'p', 'span', 'a', 'ul', 'ol', 'label',
    'li', 'em', 'br', 'div', 'img', 'iframe',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'video',
    'source'
  ],
  allowedAttributes: {
    '*': ['id', 'class', 'style'],
    a: [
      'href', 'target', 'title', 'tabindex', 'accesskey',
      'lang', 'charset', 'name', 'type', 'dir', 'rel'
    ],
    img: ['src', 'alt', 'width', 'height', 'title', 'longdesc', 'lang'],
    th: ['colspan', 'rowspan'],
    td: ['colspan', 'rowspan'],
    iframe: ['src', 'allow', 'allowfullscreen', 'frameborder'],
    button: ['autofocus', 'disabled', 'type'],
    label: ['for'],
    video: ['autoplay','controls','loop','muted','onclick','poster','playsinline','preload','src'],
    source: ['src']
  },
  allowedSchemes: [
    // javascriptだけは除外したい
    'http', 'https', 'ftp', 'mailto', 'tel', 'data', 'file'
  ]
}

export function sanitizeHTML(html) {
  return sanitize(html, commonSanitizeOption)
}

export function clearHTML(html) {
  return sanitize(html, { allowedTags: [] })
}

/**
 * 自動スクロール
 */
export function linkScroll(to, option = {}) {
  // 遷移先がなかった場合
  if (document.querySelector(to) === null) {
    return false;
  }

  // ヘッダー固定なので、その分の高さを考慮する
  const navbarHeight = document.querySelector('.navbar').clientHeight
  const defaultOption = { duration: 300, offset: -1 * (navbarHeight + 16) }

  jump(to, Object.assign({}, defaultOption, option))
}

export function breakLine(str) {
  return clearHTML(str).replace(/\r?\n/g, '<br />')
}
